import React from 'react';
import { CheckboxProps } from 'components/Checkbox';
import { Dropdown, Menu, MenuItem, Icon, Button } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { ShowingsCalendarAppointmentStatus } from '../types';
import SearchBar from './SearchBar';
import StatusMenuMobile from './StatusMenuMobile';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';
import DateRangePicker, { DateRangePickerProps } from '../DateRangePicker';

type ToolBarMobileProps = {
  isSearchClicked: boolean;
  setIsSearchClicked: React.Dispatch<React.SetStateAction<boolean>>;
  localStatuses: ShowingsCalendarAppointmentStatus[] | undefined;
  setLocalStatuses: React.Dispatch<
    React.SetStateAction<ShowingsCalendarAppointmentStatus[] | undefined>
  >;
  statusOnChange: (
    key: ShowingsCalendarAppointmentStatus,
  ) => CheckboxProps['onChange'];
  dateRangeOnChange: (date: [moment.Moment, moment.Moment]) => void;
  dateRangeOpen: boolean;
  setDateRangeOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ToolBarMobile: React.FC<ToolBarMobileProps> = ({
  isSearchClicked,
  setIsSearchClicked,
  localStatuses,
  setLocalStatuses,
  statusOnChange,
  dateRangeOnChange,
  dateRangeOpen,
  setDateRangeOpen,
}) => {
  const [statusFilterOpen, setStatusOpen] = React.useState<boolean>(false);
  const context = useShowingsCalendarContext();
  const { date } = context;
  const { md } = useBreakpoint();

  React.useEffect(() => () => {
      setIsSearchClicked(false);
      setStatusOpen(false);
    }, [setIsSearchClicked, setStatusOpen]);

  return (
    <>
      <StyeldSearchIconContainer
        $isSearchClicked={isSearchClicked}
        onClick={() => setIsSearchClicked(true)}
      >
        <Icon type="search" width={19} />
      </StyeldSearchIconContainer>
      <StyledSearchContainer $isSearchClicked={isSearchClicked}>
        <Button
          icon={<Icon type="antdLeftOutlined" />}
          onClick={() => setIsSearchClicked(false)}
          type="text"
        />
        <SearchBar />
      </StyledSearchContainer>

      <Dropdown
        trigger={['click']}
        dropdownRender={() => (
          <Menu>
            {md && (
              <MenuItem
                key={'filter-date'}
                onClick={() => setDateRangeOpen(true)}
              >
                Filter by Date
              </MenuItem>
            )}
            <MenuItem key={'filter-status'} onClick={() => setStatusOpen(true)}>
              Filter by Status
            </MenuItem>
          </Menu>
        )}
      >
        <StyledEllipsisButton
          type="text"
          $isSearchClicked={isSearchClicked}
          icon={<Icon type="ellipsis" width={25} />}
        />
      </Dropdown>
      {statusFilterOpen && (
        <StatusMenuMobile
          setStatusOpen={setStatusOpen}
          localStatuses={localStatuses}
          setLocalStatuses={setLocalStatuses}
          statusOnChange={statusOnChange}
        />
      )}
      {dateRangeOpen && (
        <DateRangePicker value={date} onChange={dateRangeOnChange} />
      )}
    </>
  );
};

const StyledEllipsisButton = styled(Button)<{ $isSearchClicked: boolean }>`
  ${({ $isSearchClicked }) => {
    if ($isSearchClicked) return 'display: none;';
  }}
  margin-right: 5px;
`;

const StyeldSearchIconContainer = styled.div<{ $isSearchClicked: boolean }>`
  display: ${({ $isSearchClicked }) => ($isSearchClicked ? 'none' : 'inline')};
`;

const StyledSearchContainer = styled.div<{ $isSearchClicked: boolean }>`
  display: ${({ $isSearchClicked }) => ($isSearchClicked ? 'block' : 'none')};
  ${({ $isSearchClicked }) => {
    if (!$isSearchClicked) return 'display: none';
  }}
  display: flex;
  align-items: center;
  padding: 5px;
`;

export default ToolBarMobile;
